<template>
  <b-row>
    <b-col>
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          style="background-color: #0080C9; color: white; font:45px; padding:15px; padding:1rem "
          header="Historial Clinico" 
          :class="{ collapsed: !visibleBody }"
          data-toggle="collapse" 
          @click="() => visibleBody = !visibleBody"  
        >
          <span class="lead collapse-title">
            <strong>Historial Atenciones</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 5px">

            <div>
              <div class="d-flex justify-content-end">
                <h6 class="text-right my-1 mx-1">Total: {{table.totalRows}}</h6>
              </div>

              <b-table 
                v-if="historialAtenciones.length"
                :items="historialAtenciones" 
                :fields="fieldsTable"
                responsive small bordered
                id = "tableHistCLinico"
              >

                <template #cell(fecha)="data">
                  <small>
                    {{ data.item.fecha}}
                  </small>
                </template>

                <template #cell(especialidad.descripcion)="data">
                  <small>
                    {{ data.item.especialidad.descripcion }}
                  </small>
                </template>

                <template #cell(doctor)="data">
                  <small>
                    {{ data.item.doctor }}
                  </small>
                </template>

                <template #cell(acciones)="data">
                  <div class="d-flex justify-content-center">
                    
                    <b-button
                      variant="info"
                      size="sm"
                      @click="viewAtencion(data.item.token)"
                      style="padding: 6px;"
                    >
                      <font-awesome-icon icon="magnifying-glass" style="color: white"/>
                    </b-button>
                    
                  </div>
                </template>
                      
              </b-table>

              <div 
                v-if="loadingData" 
                class="mt-3 d-flex justify-content-center"
              >
                <b-spinner 
                  style="width: 3rem; height: 3rem;" 
                  variant="primary"
                /> 
              </div>

              <EmptyResults
                size="sm"
                v-if="!historialAtenciones.length && !loadingData"
              />

              <div
                v-if="historialAtenciones.length && table.totalRows > table.perPage"
                class="d-flex justify-content-center"
              >
                <b-pagination
                  v-model="table.page"
                  :total-rows="historialAtenciones.length"
                  :per-page="table.perPage"
                  aria-controls="table-img"
                />
              </div>

              <HistorialAtencionModal/>
              
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>

  
</template>
  
<script>
import { BootstrapVue } from 'bootstrap-vue';
import { EmptyResults } from '@/shared/components';
import { atencionMedicaService } from '../../../atencionMedica/services/atencionMedicaService/atencionMedicaService';
import HistorialAtencionModal from './HistorialAtencionModal.vue';
  
export default {

  name: "HistorialAtenciones",

  props: {
    itemCita  : Array,
    itemCitas : Object,
    idPaciente: String
  },

  components: {
    ...BootstrapVue.components,
    HistorialAtencionModal,
    EmptyResults
  },

  data() {
    return {
      visibleBody: false,

      historialAtenciones: [],

      table:{
        page: 1,
        perPage: 6,
        totalRows: 0
      },

      loadingData: false,
    
      fieldsTable: [

        {
          key: "fecha",
          label: "Fecha",
          sortable: false,
          thClass: "text-center",
        },
        {
          key: "especialidad.descripcion",
          label: "Especialidad",
          sortable: false,
          thClass: "text-center",
        },
        {
          key: "doctor",
          label: "Doctor",
          sortable: false,
          thClass: "text-center",
        },
        {
          key: "acciones",
          label: "Ver",
          sortable: false,
          thClass: "text-center",
        },
      ],

      showSpinner: true,
    }
  },
  created() {
    this.loadDataHistorial();
  },

  
  methods: {

    async loadDataHistorial(){

      this.loadingData = true;

      const responseAtenciones = await atencionMedicaService.getAllAtencionesByPaciente(this.idPaciente);
      if(!responseAtenciones) {
        this.loadingData = false;
        return;
      }

      this.table.totalRows = responseAtenciones.total;
      const mapperAtenciones = responseAtenciones.atenciones.map(item => {

        return {
          id: item.id,
          token: item.token,
          fecha: item.cita.fechaCita,
          especialidad: item.cita.doctor.especialidad,
          doctor: `${item.cita.doctor.idPersona.primerApellido} ${item.cita.doctor.idPersona.primerNombre}`,
        }
      });

      this.historialAtenciones = mapperAtenciones;
      this.loadingData = false;
    },


    viewAtencion(tokenAtencion){

      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query, 
            view_atencion_historial: tokenAtencion
          }
        });
      } catch (error) { console.log("este es el rror", error) }
    }

  },
};
</script>
  